import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_6 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_7 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "text-center text-muted py-4"
}
const _hoisted_16 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_17 = { class: "mb-0 text-paragraph" }
const _hoisted_18 = { class: "fw-bold" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = { class: "mt-15 mt-md-0" }
const _hoisted_21 = { class: "pagination mb-0" }
const _hoisted_22 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
        _createElementVNode("h5", { class: "text-black fw-semibold mb-0" }, "Confirmation des paiements")
      ], -1)),
      _createVNode(_component_router_link, {
        to: "/OuverturesFermetures",
        class: "btn btn-primary"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Retour à la liste")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date Règlement "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Montant Payé "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Mode de règlement "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Statut "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Actions ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reglements, (reglement, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.format_date(reglement.date)), 1),
                _createElementVNode("td", _hoisted_7, [
                  (reglement?.creance?.client)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(reglement?.creance?.client?.nomClient && reglement?.creance?.client?.prenomClient ?
                    `${reglement?.creance?.client?.nomClient} ${reglement?.creance?.client?.prenomClient}`
                    : reglement?.creance?.client?.raisonSociale), 1))
                    : (reglement?.commandeClient?.client)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(reglement?.commandeClient?.client?.nomClient && reglement?.commandeClient?.client?.prenomClient ?
                    `${reglement?.commandeClient?.client?.nomClient} ${reglement?.commandeClient?.client?.prenomClient}`
                    : reglement?.commandeClient?.client?.raisonSociale), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, "Non défini"))
                ]),
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.separateur(reglement.montantPaye)) + " FCFA", 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(reglement?.modeReglement?.libelle), 1),
                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium" }, [
                  _createElementVNode("span", { class: "badge bg-warning" }, "En attente de confirmation")
                ], -1)),
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.confirmerPaiement(reglement.id)),
                    class: "btn btn-success btn-sm"
                  }, _cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "flaticon-checkmark lh-1 me-8 position-relative top-1" }, null, -1),
                    _createTextVNode("Confirmer ")
                  ]), 8, _hoisted_14)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      (_ctx.reglements.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Aucun règlement en attente de confirmation "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("p", _hoisted_17, [
          _cache[7] || (_cache[7] = _createTextVNode(" Affichage de ")),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.reglements.length), 1),
          _cache[8] || (_cache[8] = _createTextVNode(" sur ")),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.totalElements), 1),
          _cache[9] || (_cache[9] = _createTextVNode(" résultats "))
        ]),
        _createElementVNode("nav", _hoisted_20, [
          _createElementVNode("ul", _hoisted_21, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                "aria-label": "Previous",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
              ]))
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item", { active: _ctx.currentPage === page }]),
                key: page
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
                }, _toDisplayString(page), 9, _hoisted_22)
              ], 2))
            }), 128)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                href: "#",
                "aria-label": "Next",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
              ]))
            ], 2)
          ])
        ])
      ])
    ])
  ]))
}